<section class="overflow-hidden bg-gray3 text-primary pb-20">
    <div class="text-center text-primary weight-600 size-14 mrtb-25">
      {{ 'account.resetThePassword' | translate }}
    </div>

    <form [formGroup]="resetForm" (ngSubmit)="resetPassword()" class="login-form mrse-20">
      <div class="mrtb-15 position-relative">
        <label class="d-block size-6 weight-600 mrb-4" for="password">{{ 'account.newPassword' | translate}}</label>
        <input class="w-100 border-0 border-radius-10 p-4" type="password" name="password" id="password" formControlName="password"  [class.is-invalid]="password?.invalid && (password?.dirty || password?.touched)"/>
            <div class="invalid-feedback">
                <p *ngIf="password?.errors?.pattern">
                    {{ 'account.newPassword'| translate }} {{ 'isInvalid'| translate }}
                </p>

                <p *ngIf="password?.errors?.required">
                    {{ 'account.newPassword'| translate }} {{ 'isRequired'| translate }}
                </p>
            </div>
      </div>
      <div class="mrtb-15 position-relative">
        <label class="d-block size-6 weight-600 mrb-4" for="confirmPassword">{{ 'account.rePassword' | translate}}</label>
        <input class="w-100 border-0 border-radius-10 p-4" type="password" name="confirmPassword" id="confirmPassword" formControlName="confirmPassword"         [class.is-invalid]="confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched)"/>
            <div class="invalid-feedback">
                <p *ngIf="confirmPassword?.errors?.invalid">
                    {{ 'account.rePassword'| translate }} {{ 'isInvalid'| translate }}
                </p>
                <p *ngIf="confirmPassword?.errors?.required">
                    {{ 'account.rePassword'| translate }} {{ 'isRequired'| translate }}
                </p>
            </div>
      </div>
    <div class="mrtb-20">
      <button class="w-100 bg-primary border-0 border-radius-10 p-5 text-white size-8 weight-600" type="submit" [disabled]="isSubmitting || resetForm.invalid">
       
        <span *ngIf="!isSubmitting">{{ 'account.resetThePassword' | translate }}</span>
				<img  *ngIf="isSubmitting" src="../../../../assets/images/spinner.gif" alt="" class="max-30">
      </button>
    </div>
    </form>
    <div>
        <div class="mrt-20"><img src="../../../../assets/images/small-line.svg" alt="line" /></div>
    </div>
  </section>
